module.exports = __webpack_public_path__ + "media/images/front/sp/atopy-control-check/bg01-c978dfeb3319d0262783fd5b79c1f5b4.png";